import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function CircularProgressWithLabel(
  props: CircularProgressProps & { value: number; text?: string }
) {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',   
      }}
    >
      <Box sx={{ position: 'relative', display: 'inline-flex',justifyContent:"center", width: '100%' , maxWidth: 150}}>
        {/* Cercle gris en arrière-plan */}
        <CircularProgress
          variant="determinate"
          value={100}
          size="100%"          // 👉 responsive (prend largeur du parent)
          thickness={4}
          sx={{ color: '#e0e0e0', position: 'absolute' }}
        />

        {/* Cercle coloré de progression */}
        <CircularProgress
          variant="determinate"
          {...props}
          size="100%"
          thickness={4}
          sx={{ color: '#3f51b5' }}
        />

        {/* Texte au centre */}
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="h6"
            component="div"
            sx={{ color: '#3f51b5', fontWeight: 'bold' }}
          >
            {`${Math.round(props.value)}%`}
          </Typography>
        </Box>
      </Box>

      {/* Texte en dessous */}
      {props.text && (
        <Typography
          variant="body2"
          sx={{ mt: 2, color: 'text.secondary', textAlign: 'center' }}
        >
          {props.text}
        </Typography>
      )}
    </Box>
  );
}
